import React from 'react';
import { Workstation } from 'app/containers/OrderDetails/types';
import { Trolley } from 'app/models/Trolley';
import { PartOrder } from 'app/models/PartOrder';
import PickingCornerPageView from 'shared/printing/pickingPresentation/PickingCornerPageView';

interface Props {
  order: PartOrder;
  trolleys: Trolley[];
  workstation: Workstation;
}

const PickingCornerPagePrintable = ({ order, trolleys, workstation }: Props) => {
  return (
    <PickingCornerPageView
      order={order}
      trolleys={trolleys}
      workstation={workstation}
    />
  );
};

export default PickingCornerPagePrintable;
